import { useEffect, useMemo, useState } from "react";
import useSWR from "swr";
import { Button, Center, HStack, Spinner } from "@chakra-ui/react";
import { Select } from "../../../components/Input";
import { fetchData } from "../../../services/fetch";

export default function TemplateSelect({
  level,
  levels,
  templates,
  templatesIsLoading,
  selectedQuestions,
  setSelectedQuestions,
}) {
  const [questionOptionsKey, setQuestionOptionsKey] = useState(0);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isSecondSelectEnabled, setIsSecondSelectEnabled] = useState(false);
  const [tempSelectedQuestion, setTempSelectedQuestion] = useState(null);

  const { data: surveyQuestions } = useSWR(
    selectedTemplate ? `/question-template/template/${selectedTemplate}` : null,
    fetchData
  );

  const templateOptions = useMemo(
    () =>
      templates?.map((template) => ({
        label: template?.name,
        value: template?.id_survey_template,
      })) || [],
    [templates]
  );

  const selectedQuestionIds = useMemo(() => {
    return new Set(selectedQuestions?.map((q) => q.id_question_template));
  }, [selectedQuestions]);

  const questionOptions = useMemo(() => {
    if (!surveyQuestions?.length) {
      return [];
    }

    const options = [];
    if (selectedQuestionIds.size !== surveyQuestions.length) {
      options.push({ label: "Todas as perguntas", value: "all" });
    }

    const individualQuestions = surveyQuestions
      ?.filter(
        (question) => !selectedQuestionIds.has(question.id_question_template)
      )
      .map((question) => ({
        label: question?.questionTitleTemplate?.[0]?.description,
        value: question?.id_question_template,
      }));

    return [...options, ...individualQuestions];
  }, [surveyQuestions, selectedQuestionIds]);

  const handleTemplateSelect = (value) => {
    setSelectedTemplate(value);
    setIsSecondSelectEnabled(true);
  };

  const handleQuestionSelect = (value) => {
    setTempSelectedQuestion(value);
  };

  const addSelectedQuestion = () => {
    if (tempSelectedQuestion === "all") {
      const allUnselectedQuestions = surveyQuestions?.filter(
        (question) => !selectedQuestionIds.has(question.id_question_template)
      );
      setSelectedQuestions([...selectedQuestions, ...allUnselectedQuestions]);
    } else {
      const selectedQuestion = surveyQuestions?.find(
        (question) => question?.id_question_template === +tempSelectedQuestion
      );
      if (
        selectedQuestion &&
        !selectedQuestionIds.has(selectedQuestion.id_question_template)
      ) {
        setSelectedQuestions([...selectedQuestions, selectedQuestion]);
      }
    }
    setQuestionOptionsKey((prevKey) => prevKey + 1);
    setTempSelectedQuestion(null);
  };

  if (templatesIsLoading) {
    return (
      <Center py="20px">
        <Spinner />
      </Center>
    );
  }

  return (
    <HStack spacing={6} align="end" mb="12px">
      <Select
        label="Template"
        placeholder="Selecione um template"
        options={templateOptions}
        onChange={(e) => handleTemplateSelect(e.target.value)}
      />
      <Select
        key={questionOptionsKey}
        label="Pergunta"
        placeholder="Selecione uma pergunta"
        options={questionOptions}
        isDisabled={!isSecondSelectEnabled || !surveyQuestions}
        onChange={(e) => handleQuestionSelect(e.target.value)}
      />
      <Button
        variant="primary"
        size="medium"
        w="137px"
        minW="137px"
        isDisabled={!tempSelectedQuestion || !tempSelectedQuestion.length}
        onClick={addSelectedQuestion}
      >
        Adicionar
      </Button>
    </HStack>
  );
}
